import {Label} from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import {Text} from '../Text';

import type {DropdownMenuLabelProps} from '@radix-ui/react-dropdown-menu';

export function DropdownLabel({
  ref: forwardedRef,
  children,
  className,
  ...props
}: DropdownMenuLabelProps &
  React.RefAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <Label
      {...props}
      ref={forwardedRef}
      className={clsx(className, 'px-2 text-sm text-slate11')}
    >
      <Text as="strong">{children}</Text>
    </Label>
  );
}

DropdownLabel.displayName = 'DropdownLabel';
